<div class="dashboard-statics p-5 md:p-6">
  <div class="statics-head">
    <div>
      <p class="eyebrow">
        {{ "STATICS.TOTAL_APPLICATION" | translate }}
      </p>
      <h4 class="title">{{ "STATICS.BY_SERVICE_CATEGORY" | translate }}</h4>
    </div>

    <div class="period-filter-wrap">
      <div class="period-filter sm:w-30">
        <app-option-field
          label=""
          placeholder=""
          [lovType]="lookupKey.DC_REPORT_PERIOD"
          [control]="filterForm.get('reportPeriod')"
          [labelKey]="'Value'"
          [valueKey]="'Name'"
          [showSelectedTooltip]="true"
          (onSelectionChange)="onReportPeriodChange()"
        >
        </app-option-field>
      </div>

      @if (showCustomDateRange) {
        <div class="custom-date-wrap pt-1">
          <div class="w-full sm:w-40">
            <div class="relative">
              <input
                type="text"
                class="calendar-field"
                [placeholder]="'PAYMENTS.FILTER.DATE_FROM' | translate"
                [value]="dateFromDisplay"
                readonly
                (click)="toggleDateCalendar('from')"
              />
              <button
                type="button"
                class="calendar-field-icon"
                (click)="toggleDateCalendar('from')"
              >
                <i class="fas fa-calendar"></i>
              </button>
              @if (dateFromDisplay) {
                <button
                  type="button"
                  class="calendar-field-clear"
                  (click)="clearDateFrom($event)"
                  aria-label="Clear date from"
                >
                  <i class="fas fa-times"></i>
                </button>
              }
              @if (showDateFromCalendar) {
                <div class="absolute z-50 mt-2">
                  <app-inline-calendar
                    [selected]="selectedDateFrom || today"
                    [disablePast]="false"
                    [disableFuture]="true"
                    (onDatePicked)="onDateFromPicked($event)"
                  ></app-inline-calendar>
                </div>
              }
            </div>
          </div>

          <div class="w-full sm:w-40">
            <div class="relative">
              <input
                type="text"
                class="calendar-field"
                [placeholder]="'PAYMENTS.FILTER.DATE_TO' | translate"
                [value]="dateToDisplay"
                readonly
                (click)="toggleDateCalendar('to')"
              />
              <button
                type="button"
                class="calendar-field-icon"
                (click)="toggleDateCalendar('to')"
              >
                <i class="fas fa-calendar"></i>
              </button>
              @if (dateToDisplay) {
                <button
                  type="button"
                  class="calendar-field-clear"
                  (click)="clearDateTo($event)"
                  aria-label="Clear date to"
                >
                  <i class="fas fa-times"></i>
                </button>
              }
              @if (showDateToCalendar) {
                <div class="absolute z-50 mt-2">
                  <app-inline-calendar
                    [selected]="selectedDateTo || today"
                    [disablePast]="false"
                    [disableFuture]="true"
                    [minDate]="selectedDateFrom"
                    (onDatePicked)="onDateToPicked($event)"
                  ></app-inline-calendar>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="chart-wrap">
    @if (isServiceSpendLoading) {
      <app-skeleton-loader></app-skeleton-loader>
    }

    @if (!isServiceSpendLoading && noServiceSpendData) {
      <div class="no-data">
         {{ "STATICS.NO_DATA_FOUND" | translate }}
      </div>
    }

    @if (!isServiceSpendLoading && !noServiceSpendData) {
      <app-chart
        [chartType]="'bar'"
        [chartData]="serviceWiseSpendChartData"
        [height]="430"
      >
      </app-chart>
    }
  </div>
</div>
